/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AbimInfo } from '../models/AbimInfo';
import type { Submissions_AnnualSummary } from '../models/Submissions_AnnualSummary';
import type { Submissions_SubmissionsByYear } from '../models/Submissions_SubmissionsByYear';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SubmissionsService {
    /**
     * Get ABIM info and submissions by year
     * @returns any successful
     * @throws ApiError
     */
    public static getSubmissionsSummary(): CancelablePromise<{
        abimInfo: AbimInfo;
        submissionsByYear: Submissions_SubmissionsByYear;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/submissions.json',
        });
    }
    /**
     * Submit credits for a year
     * @param requestBody
     * @returns Submissions_AnnualSummary successful
     * @throws ApiError
     */
    public static submitCredits(
        requestBody?: {
            year: number;
            creditsClaimed: number;
            expectedTotalCredits: number;
            email?: string;
            sendEmail?: boolean;
        },
    ): CancelablePromise<Submissions_AnnualSummary> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/submissions.json',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get annual summary for a year
     * @param id Year
     * @returns Submissions_AnnualSummary successful
     * @throws ApiError
     */
    public static getSubmissionAnnualSummary(
        id: string,
    ): CancelablePromise<Submissions_AnnualSummary> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/submissions/{id}.json',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Get ABIM info
     * @returns AbimInfo successful
     * @throws ApiError
     */
    public static getAbimInfo(): CancelablePromise<AbimInfo> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/submissions/abim_info.json',
        });
    }
    /**
     * Update ABIM info
     * @param requestBody
     * @returns AbimInfo successful
     * @throws ApiError
     */
    public static updateAbimInfo(
        requestBody?: AbimInfo,
    ): CancelablePromise<AbimInfo> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/submissions/abim_info.json',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
